/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycProcessApprovalDto } from '../../models/kyc-process-approval-dto';

export interface GetApprovals$Params {
  processId: string;
}

export function getApprovals(http: HttpClient, rootUrl: string, params: GetApprovals$Params, context?: HttpContext): Observable<StrictHttpResponse<KycProcessApprovalDto>> {
  const rb = new RequestBuilder(rootUrl, getApprovals.PATH, 'get');
  if (params) {
    rb.path('processId', params.processId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycProcessApprovalDto>;
    })
  );
}

getApprovals.PATH = '/kyc/processes/{processId}/approvals';
